import httpService from "./httpService";
import utils from "./utils";

export default {
  // get: function () {
  //   return httpService.get("delegate", null);
  // },

  update(id, form) {
    return httpService.put(`/delegate/${id}`, form);
  },

  save(form) {
    return httpService.post(`/delegate`, form);
  },

  findAll(example, pageable) {
    // return httpService.get(`/delegate/findAll`)
    let params = utils.merge(example, pageable);
    return httpService.get("/delegate", {params: params});
  },

  count(example) {
    return httpService.get("delegate/count", {params: example});
  },

  findById(id) {
    return httpService.get("delegate/" + id);
  },

  changeStatus(id, status) {
    return httpService.put(`/delegate/${id}/changeStatus`, {status: status});
  },

  delete(id) {
    return httpService.delete(`/delegate/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/vbDelegateInfoService.js